import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
interface ToolItemProps {
  name: string;
  icon: string;
  delay: number;
}
function ToolItem({
  name,
  icon,
  delay
}: ToolItemProps) {
  return <motion.div className="flex flex-col items-center p-4" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: delay * 0.1
  }} data-id="element-169">
      <div className="w-16 h-16 flex items-center justify-center mb-3 bg-gray-100 rounded-xl shadow-sm" data-id="element-170">
        <img src={icon} alt={name} className="w-10 h-10 object-contain" data-id="element-171" />
      </div>
      <span className="text-sm font-medium text-gray-700" data-id="element-172">{name}</span>
    </motion.div>;
}
export function Tools() {
  const tools = [{
    name: 'Canva',
    icon: 'https://cdn-images-1.medium.com/max/1200/1*A6kkoOVJVpXPWewg8axc5w.png'
  }, {
    name: 'Adobe Creative Suite',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Adobe_Creative_Cloud_rainbow_icon.svg/512px-Adobe_Creative_Cloud_rainbow_icon.svg.png'
  }, {
    name: 'Figma',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg'
  }, {
    name: 'Miro',
    icon: 'https://asset.brandfetch.io/idFdo8ulhr/idzj70VcsE.png'
  }, {
    name: 'ChatGPT',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/512px-ChatGPT_logo.svg.png'
  }, {
    name: 'Articulate',
    icon: 'https://www.articulate.com/assets/img/brand/articulate-logo-a.png'
  }, {
    name: 'Notion',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png'
  }, {
    name: 'Google Workspace',
    icon: 'https://workspace.google.com/static/img/products/png/drive.png?cache=1'
  }, {
    name: 'Microsoft Office',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Microsoft_Office_logo_%282019%E2%80%93present%29.svg/1200px-Microsoft_Office_logo_%282019%E2%80%93present%29.svg.png'
  }, {
    name: 'Slack',
    icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111615.png'
  }, {
    name: 'Zoom',
    icon: 'https://download.logo.wine/logo/Zoom_Video_Communications/Zoom_Video_Communications-Logo.wine.png'
  }, {
    name: 'Trello',
    icon: 'https://cdn-icons-png.flaticon.com/512/6124/6124991.png'
  }];
  return <Section id="tools" title="Some Tools I Use" className="bg-gray-50" data-id="element-173">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 max-w-6xl mx-auto" data-id="element-174">
        {tools.map((tool, index) => <ToolItem key={tool.name} name={tool.name} icon={tool.icon} delay={index} data-id="element-175" />)}
      </div>
    </Section>;
}